import styled from "styled-components";
import * as Color from "../../general/Color";

export const EditorRoot = styled.div`
  font-family: "Source Code Pro";
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.25rem;
  overflow: hidden;
  box-sizing: border-box;
  height: 100%;

  &.disabled {
    pointer-events: none;
  }

  &.no-scroll {
    textarea {
      overflow: hidden;
    }
  }
/*

  // Disabling right now to determine if this has any effect on anything.

  code[class*="language-"],
  pre[class*="language-"] {
    text-align: left;
    -webkit-hyphens: none;
    -moz-hyphens: none;
    -ms-hyphens: none;
    hyphens: none;
  }

  pre[class*="language-"]::-moz-selection, pre[class*="language-"] ::-moz-selection,
  code[class*="language-"]::-moz-selection, code[class*="language-"] ::-moz-selection {
    text-shadow: none;
    background: #b3d4fc;
  }

  pre[class*="language-"]::selection, pre[class*="language-"] ::selection,
  code[class*="language-"]::selection, code[class*="language-"] ::selection {
    text-shadow: none;
    background: #b3d4fc;
  }

  @media print {
    code[class*="language-"],
    pre[class*="language-"] {
      text-shadow: none;
    }
  }

  pre[class*="language-"] {
    padding: 1em;
    margin: .5em 0;
    overflow: auto;
  }

  :not(pre) > code[class*="language-"],
  pre[class*="language-"] {
    background: #f5f2f0;
  }

  :not(pre) > code[class*="language-"] {
    padding: .1em;
    border-radius: .3em;
    white-space: normal;
  }
*/

  // Apply theming.

  color: ${({ theme }) => Color.toString(theme.primary)};
  .preview {
    background-color: ${({ theme }) => Color.toString(theme.background)} !important;
  }

  &.read-only {
    .preview {
      background-color: ${Color.toString(Color.LightGrey[100])} !important;
    }
  }

  .token.comment { color: ${({ theme }) => Color.toString(theme.comment)}};
  .token.prolog { color: ${({ theme }) => Color.toString(theme.prolog)}};
  .token.doctype { color: ${({ theme }) => Color.toString(theme.doctype)}};
  .token.cdata { color: ${({ theme }) => Color.toString(theme.cdata)}};
  .token.punctuation { color: ${({ theme }) => Color.toString(theme.punctuation)}};
  .token.namespace  { color: ${({ theme }) => Color.toString(theme.namespace)}};
  .token.property { color: ${({ theme }) => Color.toString(theme.property)}};
  .token.tag { color: ${({ theme }) => Color.toString(theme.tag)}};
  .token.boolean { color: ${({ theme }) => Color.toString(theme.boolean)}};
  .token.number { color: ${({ theme }) => Color.toString(theme.number)}};
  .token.constant { color: ${({ theme }) => Color.toString(theme.constant)}};
  .token.symbol { color: ${({ theme }) => Color.toString(theme.symbol)}};
  .token.deleted { color: ${({ theme }) => Color.toString(theme.deleted)}};
  .token.selector { color: ${({ theme }) => Color.toString(theme.selector)}};
  .token.attr-name { color: ${({ theme }) => Color.toString(theme.attrName)}};
  .token.string { color: ${({ theme }) => Color.toString(theme.string)}};
  .token.char { color: ${({ theme }) => Color.toString(theme.char)}};
  .token.builtin { color: ${({ theme }) => Color.toString(theme.builtIn)}};
  .token.inserted { color: ${({ theme }) => Color.toString(theme.inserted)}};
  .token.property.string-property { color: ${({ theme }) => Color.toString(theme.string)}}; // Treat string properties like strings.
  .token.operator { color: ${({ theme }) => Color.toString(theme.operator)}};
  .token.entity { color: ${({ theme }) => Color.toString(theme.entity)}};
  .token.url { color: ${({ theme }) => Color.toString(theme.url)}};
  .language-css .token.string { color: ${({ theme }) => Color.toString(theme.cssString)}};
  .style .token.string { color: ${({ theme }) => Color.toString(theme.cssString)}};
  .token.atrule { color: ${({ theme }) => Color.toString(theme.atRule)}};
  .token.attr-value { color: ${({ theme }) => Color.toString(theme.attrValue)}};
  .token.keyword { color: ${({ theme }) => Color.toString(theme.keyword)}};
  .token.class-name { color: ${({ theme }) => Color.toString(theme.className)}};
  .token.function { color: ${({ theme }) => Color.toString(theme.function)}};
  .token.regex { color: ${({ theme }) => Color.toString(theme.regex)}};
  .token.important { color: ${({ theme }) => Color.toString(theme.important)}};
  .token.variable { color: ${({ theme }) => Color.toString(theme.variable)}};
`;
